import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGINS } from "./constants";
import queryKeys from "./queryKeys";

export interface MarginsResponse {
  sma: number;
  dayTradeBuyingPower: number;
  overnightBuyingPower: number;
  marginEquity: number;
  marginExcess: number;
  marginRequirement: number;
  cashAvailableToWithdraw: number;
  totalConcentrationExcess: number;
  marginConcentrationExcess: number;
  fullyPaidUnsettledFunds: number;
  cashExcessEquity: number;
  netLiquidity: number;
  totalMarketValue: number;
  liquidatingEquity: number;
  marginEquityPercent: number;
  committedSma: number;
  regTBuyingPower: number;
  fdicBalance: number;
  concentratedMaintExcess: number;
  pendingInterest: number;
  pendingDividend: number;
  processDate: string;
  groupIdentifier: string | null;
  groupAvailableToWithdraw: number;
  groupedAccounts: string[] | null;
  marginExcessEquityNYSE: number;
  unsettledCash: number;
  nonOptionsRequirement: number;
  nonOptionsRequirementNotConcentrated: number;
  optionsRequirement: number;
  marginRequirementNYSE: number;
  cashMarketValue: number;
  marginMarketValue: number;
  shortMarketValue: number;
}

export function useGetMargins(account: string, processDate?: string) {
  const apiURL = `${getAppConfigSetting("apiUrl")}${GET_MARGINS}`;

  const fetchBalances = async () => {
    const { data } = await axios.get<MarginsResponse>(
      `${apiURL}/${account}${processDate ? `?processDate=${processDate}` : ""}`,
      {
        withCredentials: true,
      }
    );
    return data;
  };

  return useQuery<MarginsResponse, AxiosError>(
    [queryKeys.getBalances, account, processDate],
    fetchBalances,
    {
      enabled: !!account,
      onSuccess: () => {},
      onError: () => {},
    }
  );
}
